import { Component, OnInit, OnChanges, SimpleChanges, DoCheck, ViewChild } from '@angular/core';
import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";
import { ImageOverlayComponent } from 'src/app/components/image-overlay/image-overlay.component';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: "app-image-overlay-widget",
  templateUrl: "./image-overlay-widget.component.html",
  styleUrls: ["./image-overlay-widget.component.css"],
})
export class ImageOverlayWidgetComponent extends MultiSourceMultiValueWidget implements OnChanges, DoCheck {
  @ViewChild(ImageOverlayComponent ) imageOverlayChild: ImageOverlayComponent ; 
  @ViewChild("dashboardModal", { static: false }) dashboardModal: ModalDirective;

  offset: number;
  public c: any;
  imageUrl = "";
  imageData="";
  embeddedDashboardId: number;
  embeddedDashboardName: string;

  liveDataOnly(): boolean {
    return (<any>this.widget).period == null || (<any>this.widget).period == "";
  }

  override eventTypes: string[]; 
  override timeSeriesEvent(type: string, uri: string): void {
    
  }

  override widgetDataLoadComplete(): void {
      
  }
  
  widgetBeforeInit() {}

  widgetAfterInit() {
    // get the offset from UTC to Local in milliseconds
    this.offset = -(new Date().getTimezoneOffset() * 60 * 1000);
    var series = [];

    this.c = <any>this.config;
    
    //this.widget.showTitle = false;
    const widgetType = this.c.type;
    var currentTime = new Date();

    this.imageUrl = this.c.imageUrl;
    this.imageData = this.c.imageData;

    for (const item of this.c.timeSeriesDetailList) {
      item.value = " - ";
      if (item.displayOption == null){
        item.displayOption = "text";
      }
    }

  }

  widgetDataLoadTimeout(){
    
  }

  public objectSelected(object){
    console.log("objectSelected", object);
    if (object.embeddedDashboard && object.embeddedDashboard.dashboardId > 0){
      this.dashboardSelected.emit({dashboardId:object.embeddedDashboard.dashboardId,dashboardIdentifier:object.embeddedDashboard.dashboardIdentifier,siteUri:object.embeddedDashboardUri,displayName:object.name,size: object.embeddedDashboard.size});
    }
  }

  refresh() {
    this.ngOnInit();
  }

  widgetLiveDataLoaded(s: any) {

  }


  widgetDataLoaded(s: SharedSeries) {
    var tsdi = this.config.timeSeriesList[s.index] as any;
    var item = this.c.timeSeriesDetailList.find(o => o.uri == s.uri);
    if(item == null)
    {
      for(const ts of this.c.timeSeriesDetailList)
      {
        let valid = true;
        if (ts.tagMatches && ts.tagMatches.length > 0)
        {
          for(const tag of ts.tagMatches)
          {
            if(! s.metaData || s.metaData[tag] || !s.metaData[(tag as any).tagName])
            {
              valid = false;
              break}
            if(s.metaData[(tag as any).tagName] != (tag as any).tagValue)
            {
              valid = false;
              break
            }
          }
        }
        if (valid)
        {
          item = ts
        }
      }
    }
    if (s.values.length > 0){
     item.value = s.values[s.values.length - 1].value;
     item.timeStamp = s.values[s.values.length - 1].timeStamp;
     this.imageOverlayChild.updateTSData(item);
    }
    else{
      item.value = " - "
    }
  }

  onLeftClick(marker, ts) {

    if (ts.leftClickWidget){
      var ids = ts.leftClickWidget.replace(':','/') + "/" + ts.uri;
      var popupHeight = 150;
      if (ts.popupHeight){
        popupHeight = ts.popupHeight;
      }
      marker.bindPopup("<iframe iframe-resizer=\"indicium\" height=\"" + popupHeight + "\" src=\"#/dashboard/" + ids + "\" frameborder=\"0\" scrolling=\"no\" onload=\"obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px'\"></iframe>").openPopup();
    }
  
  }

  widgetDataAdded(s: SharedPoint) {
  }

  ngDoCheck() {

  }

  ngOnChanges(changes: SimpleChanges) {
  }

}
